<!--P007-->
<template>
  <div class="div_content">
    <div class="cs_margin_top_sm ui_hierarchy">
      <div class="cs_cursor_pointer ui_txt_hierarchy" @click="$router.push({name:'SupplierManage'})">供应商维护</div>
      <div class="ui_txt_hierarchy">&nbsp;>&nbsp;</div>
      <div class="cs_font_bold cs_cursor_pointer ui_txt_hierarchy">添加供应商</div>
    </div>
    <!--基本信息-->
    <div class="cs_margin_top ui_divider_title">
      <div class="divider_title_info"></div>
      <div class="title_info">基本信息</div>
    </div>
    <div class="cs_margin_top div_search">
      <div class="cs_title_primary cs_text_default type_info_search">供应商编号</div>
      <input v-model="search.num" class="cs_input cs_radius_lg edtxt_info_search" placeholder="请输入">
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_left">供应商名称</div>
      <input v-model="search.name" @input="transformCnChar" class="cs_input cs_radius_lg edtxt_info_search width_280" placeholder="请输入">
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_left">拼音码</div>
      <input v-model="search.spellCode" class="cs_input cs_radius_lg edtxt_info_search ui_margin_left_30" placeholder="请输入">
      <br>
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_top_sm">联系人</div>
      <input v-model="search.contactName" class="cs_input cs_radius_lg edtxt_info_search cs_margin_top_sm ui_margin_left_44" placeholder="非必填">
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_left cs_margin_top_sm">联系方式</div>
      <input v-model="search.mobileNo" class="cs_input cs_radius_lg edtxt_info_search cs_margin_top_sm ui_margin_left_30 width_280" placeholder="非必填">
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_top_sm cs_margin_left">启用状态</div>
      <div class="cs_radius_lg txt_info_search cs_margin_top_sm">启用</div>
      <br>
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_top_sm">在途天数</div>
      <input v-model="search.transitDay" @keyup="checkNonNegativeInt($event)" @blur="search.transitDay=checkNonNegativeIntBlur($event)" class="cs_input cs_radius_lg edtxt_info_search cs_margin_top_sm ui_margin_left_30" placeholder="请输入">
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_left cs_margin_top_sm">月采购频次</div>
      <input v-model="search.purchaseFrequency" @keyup="checkPositiveInt($event)" @blur="search.purchaseFrequency=checkPositiveInt($event)" class="cs_input cs_radius_lg edtxt_info_search cs_margin_top_sm width_280" placeholder="请输入">
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_top_sm cs_margin_left">结算类型</div>
      <web-select :options="SETTLE_TYPE"
                  @option-key="updateType"
                  v-model="search.typeName"
                  class="cs_input cs_radius_lg edtxt_info_search cs_margin_top_sm"></web-select>
    </div>
    <div class="div_operation_table cs_align_center" style="margin-top:350px;">
      <button @click="btnCancel" class="cs_btn cs_btn_sm ui_btn_ghost_blue"
              type="button">取消
      </button>
      <button @click="btnSave" class="cs_btn cs_btn_sm ui_btn_blue ui_margin_left_88"
              type="button">确认
      </button>
    </div>
    <div class="div_bottom"></div>
  </div>
</template>

<script>
  import WhParameter from "../../assets/csui/parameter/WhParameter"
  import {SETTLE_TYPE} from "../../assets/utils/constants"
  import WebSelect from "../../components/web-select";
  export default {
    name: "SupplierAdd",
    components: {WebSelect},
    data: function () {
      return {
        search: {
          num: "",
          name: "",
          contactName: "",
          mobileNo: "",
          spellCode: "",
          transitDay:"",
          purchaseFrequency:"",
          typeId:0,
          typeName:""
        },
        SETTLE_TYPE: SETTLE_TYPE
      }
    },
    created: function () {
    },
    mounted: function() {
    },
    methods: {
      btnSave(){
        try {
          WhParameter.verifyNotEmpty(this.search.num, "供应商编号");
          WhParameter.verifyNotEmpty(this.search.name, "供应商名称");
          WhParameter.verifyNotEmpty(this.search.spellCode, "拼音码");
          WhParameter.verifyNotEmpty(this.search.transitDay, "在途天数");
          WhParameter.verifyNotEmpty(this.search.purchaseFrequency, "月采购频次");
        }catch (e) {
          this.$toast(e.message);
          return;
        }
        if(this.isEmptySelect(this.search.typeId)){
          this.$toast("请选择结算类型");
          return;
        }
        this.$ajax.supplier.add.bind(this)(this.search,(data) => {
          this.$toast("添加成功");
          this.$router.replace({name:'SupplierManage'});
        }, (data) => {
        }, true)
      },
      btnCancel(){
        this.$router.go(-1);
      },
      transformCnChar() {
        let char = this.search.name;
        this.search.spellCode = pinyinUtil.getFirstLetter(char);
      },
      updateType(key) {
        this.search.typeId = key;
      },
    },
  }
</script>

<style scoped>
  .width_468{
    width: 468px;
  }
  .width_280{width: 280px;}
</style>



// WEBPACK FOOTER //
// src/page/supplier/SupplierAdd.vue